<script>
import Layout from '@layouts/main'
import lazyLoadComponent from '@router/lazyload-component'
import { messageStore, messageDelete } from '@utils/message'
import { messageBoxLeave } from '@utils/message-box'
import formatDate, { formatRequestData } from '@utils/format-date'

const initData = () => {
  return {
    state: 0,
    title: '',
    description: '',
    point: 0,
    price: 0,
    startDate: '',
    endDate: '',
    tagIds: []

  }
}

export default {
  components: {
    Layout,
  },
  filters: {
    formatDate
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    defaultValue: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      submitData: Object.assign({}, initData(), this.defaultValue),
      tagList: [],
      tryingStore: false,
    }
  },
  computed: {

    formRules() {
      return {
        title: [
          {
            required: true,
            message: '請輸入儲值金方案名稱'
          }
        ],
        startDate: [
          {
            required: true,
            message: '請輸入銷售開始時間'
          }
        ],
        point: [
          {
            type: 'number',
            min: 0,
            message: '必須是數字且數字要大於等於0'
          }
        ],
        price: [
          {
            type: 'number',
            min: 0,
            message: '必須是數字且數字要大於等於0'
          }
        ],
      }
    },
    isEditMode() {
      return !!this.defaultValue.id
    },
    productBaseBookingUrl() {
      let url = ''
      if (window.globalData.APP_ENV === 'local') {
        url = this.merchantUrl
      } else {
        const prefixUrl = this.merchantUrl.split('//', 2)
        url = `${prefixUrl[0]}//${this.currentMerchant.alias}.${prefixUrl[1]}`
      }
      return url
    },
    pagination() {
      return this.$route.params.pagination
    },
    filterData() {
      return this.$route.params.filterData
    }
  },
  created() {
    this.tryToFetchTags()
    if (!this.isEditMode) {
      this.submitData.startDate = formatDate(new Date(), 'date-dash')
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    async onClickLeave() {
      try {
        if (!this.isEditMode) {
          await messageBoxLeave('儲值金方案')
          this.$router.push({ name: 'deposit', params: { pagination: this.pagination, filterData: this.filterData } })
        }
        this.$router.push({ name: 'deposit', params: { pagination: this.pagination, filterData: this.filterData } })
      } catch (error) {
      } finally {
      }
    },
    /**
     * @description 批次儲存儲值金假資料
     */
    async storeFakeDataForDeposit() {
      for (let i = 0, len = 100; i < len; i++) {
        this.submitData.title = `fake-${i}`
        await this.$store.dispatch('deposit/store', this.submitData)
      }
    },
    async validateSubmitData() {
      return new Promise((resolve, reject) => {
        if (this.submitData.costPrice === "") {
          this.$set(this.submitData, 'costPrice', null)
          resolve()
        }
        if (typeof this.submitData.costPrice === 'string' && this.submitData.costPrice.length > 0) {
          reject(new Error('成本價請填入數字'))
        }
        if (typeof this.submitData.costPrice === 'number' && this.submitData.costPrice < 0) {
          reject(new Error('成本價請填入數字'))
        }
        resolve()
      })
    },
    async tryToStore() {
      try {
        await this.validate()
        this.tryingStore = true
        // await this.storeFakeDataForDeposit() // 批次新增假資料
        await this.validateSubmitData()
        await this.$store.dispatch('deposit/store', this.submitData)
        if (!this.isEditMode) {
          messageStore('add')
        } else {
          messageStore('edit')
        }
        this.$router.push({ name: 'deposit', params: { pagination: this.pagination, filterData: this.filterData } })
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.tryingStore = false
      }
    },
    async tryToFetchTags() {
      this.tagList = await this.$store.dispatch('member/fetchTags', {

      })
    },

  },
}
</script>

<template>
  <Layout>
    <div :class="$style.pageContent">
      <div :class="$style.set">
        <el-page-header content="方案設定" @back="onClickLeave"></el-page-header>
      </div>
      <div class="isStylePageContent isPaddingBottom">
        <el-form ref="form" :model="submitData" :rules="formRules" :validate-on-rule-change="false" label-position="top"
          :class="$style.form" autocomplete="off">
          <!-- <h4 class="form-block-title">是否開放購買與顯示</h4> -->
          <el-row style="border-bottom:#dcdfe6 1px solid;margin-bottom:20px">
            <el-col :span="12">
              <div class="inline-between text-text" style="margin-top: 20px;margin-bottom:20px;padding-right:40px">
                <span>是否上架方案？</span>
                <el-switch v-model="submitData.state" active-text="是" inactive-text="否" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>

            </el-col>

            <el-col :span="12">

              <div class="inline-between text-text" style="margin-top: 20px;margin-bottom:20px;padding-left:40px">
                <span>是否置頂？</span>
                <el-switch v-model="submitData.keepTop" active-text="是" :active-value="1" inactive-text="否"
                  :inactive-value="0"></el-switch>
              </div>

            </el-col>
          </el-row>



          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="名稱" prop="title" required>
                <el-input v-model="submitData.title" />
              </el-form-item>
            </el-col>



            <el-col :span="12" :sm="12">
              <el-form-item label="儲值點數" prop="point" required>
                <el-input v-model.number="submitData.point" min="0">
                  <span slot="suffix" style="margin-right:10px">點</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" :sm="12">
              <el-form-item label="售價" prop="price" required>
                <el-input v-model.number="submitData.price" min="0">
                  <span slot="suffix" style="margin-right:10px">元</span>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24" :class="$style.costPriceClass">
              <el-form-item label="成本價" prop="costPrice">
                <el-input v-model.number="submitData.costPrice" min="0">
                  <span slot="suffix" style="margin-right:10px">元</span>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="銷售起始日期" prop="startDate">
                <el-date-picker v-model="submitData.startDate" format="yyyy/MM/dd" value-format="yyyy-MM-dd"
                  type="date" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="銷售結束日期" prop="endDate">
                <el-date-picker v-model="submitData.endDate" format="yyyy/MM/dd" value-format="yyyy-MM-dd" type="date" />


              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="適用對象">
                <el-select v-model="submitData.tagIds" value-key="id" multiple placeholder="請選擇">
                  <el-option v-for="tag in tagList" :key="tag.id" :label="tag.title" :value="tag.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>


            <el-col :span="24">
              <el-form-item label="方案介紹" prop="description">
                <el-input v-model="submitData.description" type="textarea" class="is-border bg-white is-round"
                  :autosize="{ minRows: 5 }" />

              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div :class="$style.footer">
        <el-button class="is-round" @click="onClickLeave">離開</el-button>
        <el-button class="is-round" type="primary" :loading="tryingStore" @click="tryToStore">{{
          isEditMode ? '修改' : '儲存'
        }}</el-button>
      </div>
    </div>
  </Layout>
</template>
<style lang="scss" module>
@import '@design';
@import '@src/design/layout_detail_steps.scss';

.form {
  :global {
    .el-input-group__prepend {
      padding-left: 0;
    }
  }
}

%img-size {
  width: calc(33.333333% - 10px);
  height: 175px;

  @include max-sm {
    width: calc(100% - 10px);
  }
}

:global {
  :local(.upload) {
    margin: 0 -10px;
    border-top: none !important;

    >div {
      @extend %img-size;
    }

    .image-and-action {
      @extend %img-size;

      &+div {
        @extend %img-size;
      }
    }
  }
}

.form-item--split {
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;

  :global {
    .el-radio-group {
      flex-shrink: 0;
      margin-right: 15px;
    }

    .el-input {
      max-width: 150px;
    }
  }
}

.set {
  padding: 5px 16px 20px;

  :global {
    .el-page-header {
      align-items: center;
      font-size: 22px;
    }

    .el-page-header__left {
      border: 1px solid $color-border-for-bg-white;
      border-radius: $border-radius;
      padding: 12px 24px;
      background-color: white;
    }
  }
}

.costPriceClass {
  :global {
    .el-form-item__label {
      &:after {
        content: "註：成本價填寫可增加數據分析計算精準度";
        font-size: 12px;
        color: #6C6C6B;
        margin-left: 10px;
      }
    }
  }
}
</style>
